import { render } from "./TableHead.vue?vue&type=template&id=c728486c&ts=true"
import script from "./TableHead.vue?vue&type=script&lang=ts"
export * from "./TableHead.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__